// extracted by mini-css-extract-plugin
export default {"list-item":"AnimeListItem_list-item__75vWD"};